import {find, firstOf, flow, get} from '@logistics-frontend/utils'
import {
  MaxTariff,
  RequirementOptionValue,
  Requirements,
  SupportedRequirement,
  ZoneInfoResponse,
} from '@yandex-taxi/js-integration-api'
import {useRequirements, useZoneInfoQuery} from '@yandex-taxi/react-integration-api'
import {useMemo} from 'react'

import {cargoTypeRequirementsToUrl} from 'src/consts'

const getCargoRequirementValue = firstOf<Requirements | undefined, RequirementOptionValue>(
  get('cargo_type_int'),
  get('cargo_type'),
)
const findCargoRequirement: (res: ZoneInfoResponse | undefined) => SupportedRequirement | undefined = flow(
  get('max_tariffs'),
  find((t: MaxTariff) => t.class === 'cargo'),
  get('supported_requirements'),
  find((r: SupportedRequirement) => r.name === 'cargo_type_int' || r.name === 'cargo_type'),
)

export const useSelectedCargoRequirement = () => {
  const [{value: requirements}] = useRequirements()
  const {data: zoneInfo} = useZoneInfoQuery()

  return useMemo(() => {
    const requirementValue = getCargoRequirementValue(requirements)
    const cargoRequirement = findCargoRequirement(zoneInfo)

    if (cargoRequirement) {
      const requirementOptions = cargoRequirement.select?.options.find(o => o?.value === requirementValue)
      const cargoType = requirementOptions ? requirementOptions.name : ''

      return cargoTypeRequirementsToUrl[cargoType]
    }
  }, [requirements, zoneInfo])
}
